import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCL5UyKJUqkFUBN5xvOilHZa-9Azun-5vc",
  authDomain: "azizanbcf.firebaseapp.com",
  projectId: "azizanbcf",
  storageBucket: "azizanbcf.appspot.com",
  messagingSenderId: "529592407374",
  appId: "1:529592407374:web:8186ebc7716d9fe655ba1f",
  measurementId: "G-W4QM7TS2W5"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);
export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});
